module.exports = __webpack_public_path__ + "img/fig25.b832e20e.jpg";